import React from 'react';
import { Grid } from '@mui/material';
import PageContainer from 'src/components/container/PageContainer';
import ProjectAdditionForm from 'src/components/forms/form-layouts/ProjectAdditionForm';

const FormProject = () => {
  return (
    <PageContainer title="Form Layouts" description="this is innerpage">
      <Grid spacing={3}>
        <Grid item lg={12} md={12} xs={12}>
          <ProjectAdditionForm />
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default FormProject;
